import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../assets/logo.png';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

const ContadorDashboard = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth() || { user: null, loading: true };

  // Verificar permisos y redirigir si no es contador
  useEffect(() => {
    if (!loading && (!user || !user.is_contador)) {
      toast.error('No tienes permisos para acceder a esta página.', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      navigate('/login');
    }
  }, [user, loading, navigate]);

  const handleLogout = async () => {
    try {
      await api.post('/api/auth/logout/', {});
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      toast.success('Sesión cerrada correctamente', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      navigate('/login');
    } catch (error) {
      toast.error('Error al cerrar sesión', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      navigate('/login');
    }
  };

  if (loading) {
    return <div className="text-white text-center">Cargando...</div>;
  }

  if (!user) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="min-h-screen flex flex-col text-white"
    >
      <header className="flex justify-between items-center p-6 bg-notaria-blue-1 bg-opacity-90 shadow-lg">
        <div className="flex items-center">
          <img src={logo} alt="Logo Notaría 4 Cantón Otavalo" className="w-16 h-16 mr-4" />
          <h1 className="text-3xl font-bold">Dashboard del Contador</h1>
        </div>
        <motion.button
          onClick={handleLogout}
          className="bg-notaria-red text-white font-bold py-2 px-4 rounded-full hover:bg-notaria-yellow hover:text-notaria-blue-1 transition-all duration-300"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Cerrar Sesión
        </motion.button>
      </header>
      <main className="flex-1 p-10">
        <motion.div
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="max-w-4xl mx-auto bg-notaria-blue-1 bg-opacity-80 p-8 rounded-xl shadow-2xl"
        >
          <h2 className="text-2xl font-semibold mb-6">Bienvenido, Contador</h2>
          <p className="mb-4">
            Desde este panel, puedes justificar depósitos, gestionar comprobantes y ver los comprobantes rechazados.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Link
              to="/justify"
              className="bg-notaria-yellow text-notaria-blue-1 font-bold py-3 px-6 rounded-full text-center hover:bg-notaria-red hover:text-white transition-all duration-300"
            >
              Justificar Depósitos
            </Link>
            <Link
              to="/rejected-comprobantes"
              className="bg-notaria-yellow text-notaria-blue-1 font-bold py-3 px-6 rounded-full text-center hover:bg-notaria-red hover:text-white transition-all duration-300"
            >
              Ver Comprobantes Rechazados
            </Link>
            {user?.is_admin && (
              <Link
                to="/admin-cobros"
                className="bg-notaria-yellow text-notaria-blue-1 font-bold py-3 px-6 rounded-full text-center hover:bg-notaria-red hover:text-white transition-all duration-300"
              >
                Resumen Admin de Cobros
              </Link>
            )}
          </div>
        </motion.div>
      </main>
      <ToastContainer />
    </motion.div>
  );
};

export default ContadorDashboard;
